import {
  ActivityStatusEnum,
  SortEnum,
  TimeslotStatusEnum,
} from '@sport-activities/sdk';
import { ActivityFilterParamsInterface } from '~/attendee/interfaces/activity-filter-params.interface';

import { environment } from '~environments/environment';

export function getDefaultFilter(
  excludeFull: boolean
): ActivityFilterParamsInterface {
  return {
    status: 'PUBLISHED' as ActivityStatusEnum,
    timeslots: {
      startDate: new Date().toISOString(),
      timeslotStatus: 'PUBLISHED' as TimeslotStatusEnum,
      excludeFull,
      tenant: [environment.tenant],
    },
    sort: {
      by: 'timeslots.startDate',
      order: 'asc' as SortEnum.ASC,
    },
    pagination: {
      from: 0,
      limit: 2000,
    },
  };
}
